/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './component004.less';
interface IComponents004Props {
  img: string;
  img1: string;
  className?: string;
}

const Components004: React.FunctionComponent<IComponents004Props> = ({
  img,
  img1,
  className,
}) => (
  <>
    <div className={`RealCase Desktop ${className}`}>
      <img src={require(`../../../../../assets/${img}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E7%A4%BE%E6%9C%83%E6%96%B0%E8%81%9E/251336/940%E8%90%AC%E4%B9%98%E5%AE%A2%E8%B3%87%E6%96%99%E5%A4%96%E6%B4%A9-%E9%9A%B1%E7%9E%9E%E4%B8%83%E5%80%8B%E6%9C%88-%E5%9C%8B%E6%B3%B0ceo%E6%8B%8D%E7%89%87%E9%81%93%E6%AD%89-i-am-sorry'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E8%B2%A1%E7%B6%93%E5%BF%AB%E8%A8%8A/179998/%E9%A6%99%E6%B8%AF%E5%AF%AC%E9%A0%BBceo-%E9%AB%98%E5%BA%A6%E9%87%8D%E8%A6%96%E8%B3%87%E6%96%99%E5%A4%96%E6%B4%A9%E4%BA%8B%E4%BB%B6-%E5%90%91%E5%8F%97%E5%BD%B1%E9%9F%BF%E5%AE%A2%E6%88%B6%E9%81%93%E6%AD%89'
          );
        }}
        className="source2"
      />
    </div>
    <div className={`RealCase Moblie ${className}`}>
      <img src={require(`../../../../../assets/${img1}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E7%A4%BE%E6%9C%83%E6%96%B0%E8%81%9E/251336/940%E8%90%AC%E4%B9%98%E5%AE%A2%E8%B3%87%E6%96%99%E5%A4%96%E6%B4%A9-%E9%9A%B1%E7%9E%9E%E4%B8%83%E5%80%8B%E6%9C%88-%E5%9C%8B%E6%B3%B0ceo%E6%8B%8D%E7%89%87%E9%81%93%E6%AD%89-i-am-sorry'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E8%B2%A1%E7%B6%93%E5%BF%AB%E8%A8%8A/179998/%E9%A6%99%E6%B8%AF%E5%AF%AC%E9%A0%BBceo-%E9%AB%98%E5%BA%A6%E9%87%8D%E8%A6%96%E8%B3%87%E6%96%99%E5%A4%96%E6%B4%A9%E4%BA%8B%E4%BB%B6-%E5%90%91%E5%8F%97%E5%BD%B1%E9%9F%BF%E5%AE%A2%E6%88%B6%E9%81%93%E6%AD%89'
          );
        }}
        className="source2"
      />
    </div>
  </>
);

export default Components004;
